import { Object3D, Vector2, Vector3 } from 'three'

export enum CARDINAL_POINT {
  NORTH = 'NORTH',
  EAST = 'EAST',
  SOUTH = 'SOUTH',
  WEST = 'WEST',
  NORTHEAST = 'NORTHEAST',
  NORTHWEST = 'NORTHWEST',
  SOUTHEAST = 'SOUTHEAST',
  SOUTHWEST = 'SOUTHWEST',
}

const PosVectors = {
  [CARDINAL_POINT.NORTH]: new Vector3(0, 0, -1),
  [CARDINAL_POINT.EAST]: new Vector3(1, 0, 0),
  [CARDINAL_POINT.SOUTH]: new Vector3(0, 0, 1),
  [CARDINAL_POINT.WEST]: new Vector3(-1, 0, 0),
}
const CoordVectors = {
  [CARDINAL_POINT.NORTH]: new Vector2(0, -1),
  [CARDINAL_POINT.EAST]: new Vector2(1, 0),
  [CARDINAL_POINT.SOUTH]: new Vector2(0, 1),
  [CARDINAL_POINT.WEST]: new Vector2(-1, 0),
}

export const lookAtCardinalPoint = (point: CARDINAL_POINT) => (obj: Object3D) => {
  let targetPoint = obj.position.clone()
  targetPoint.add(getPositionVectorFromCardinalPoint(point))
  obj.lookAt(targetPoint)
}

export const getPositionVectorFromCardinalPoint = (point: CARDINAL_POINT) => {
  switch (point) {
    default:
    case CARDINAL_POINT.NORTH:
      return PosVectors[CARDINAL_POINT.NORTH]

    case CARDINAL_POINT.EAST:
      return PosVectors[CARDINAL_POINT.EAST]

    case CARDINAL_POINT.SOUTH:
      return PosVectors[CARDINAL_POINT.SOUTH]

    case CARDINAL_POINT.WEST:
      return PosVectors[CARDINAL_POINT.WEST]

    case CARDINAL_POINT.NORTHEAST:
      return PosVectors[CARDINAL_POINT.NORTH].clone().add(PosVectors[CARDINAL_POINT.EAST])

    case CARDINAL_POINT.NORTHEAST:
      return PosVectors[CARDINAL_POINT.NORTH].clone().add(PosVectors[CARDINAL_POINT.EAST])

    case CARDINAL_POINT.SOUTHEAST:
      return PosVectors[CARDINAL_POINT.SOUTH].clone().add(PosVectors[CARDINAL_POINT.EAST])

    case CARDINAL_POINT.SOUTHWEST:
      return PosVectors[CARDINAL_POINT.SOUTH].clone().add(PosVectors[CARDINAL_POINT.WEST])
  }
}

export const getCoordsVectorFromCoords = (origin: Vector2, target: Vector2) => {
  const o = new Vector2(0, 0)
  // since 0,0 is top left in the grid, positive y values moves towards south (down).
  // Notice the difference with cartesian coordinate system when positive y values represents north (up).
  if(origin.y > target.y) {
    // north
    o.add(CoordVectors[CARDINAL_POINT.NORTH])
  }
  if(origin.y < target.y) {
    // south
    o.add(CoordVectors[CARDINAL_POINT.SOUTH])
  }
  if(origin.x > target.x) {
    // west
    o.add(CoordVectors[CARDINAL_POINT.WEST])
  }
  if(origin.x < target.x) {
    // east
    o.add(CoordVectors[CARDINAL_POINT.EAST])
  }

  return o
}